import { render, staticRenderFns } from "./ToolShape.vue?vue&type=template&id=6b6170e7&"
import script from "./ToolShape.vue?vue&type=script&lang=js&"
export * from "./ToolShape.vue?vue&type=script&lang=js&"
import style0 from "./ToolShape.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports